import { Box, Typography } from "@mui/material";
import { Place } from "@mui/icons-material";
import { LocationTypeProps } from "../../../../hooks/location/index.type";
import PinPointSelector from "../../../PinPointSelector";
export default function PinPointMarker({
  name,
  handleLocationSelect,
  rotation,
  type = 'waypoint'
}: {
  name: string,
  handleLocationSelect?: (name: string) => void,
  rotation?: number,
  type?: LocationTypeProps
}) {
  return (
    <>
      <Box
        onClick={() => handleLocationSelect?.(name)}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyItems: 'center',
          position: 'relative',
          transform: `rotate(${rotation || 0}deg)`
        }}
      >
        <PinPointSelector type={type} style={{ fontSize: 36 }} />
        <Typography
          variant="subtitle2"
          sx={{
            color: '#1565C0',
            fontSize: '14px',
            textAlign: "center",
            wordBreak: 'keep-all',
            width: '100%'
          }}
        >
          {name}
        </Typography>
      </Box>
    </>
  )
}